import { render, staticRenderFns } from "./OrganizationForm.vue?vue&type=template&id=212bf684&scoped=true&"
import script from "./OrganizationForm.vue?vue&type=script&lang=js&"
export * from "./OrganizationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212bf684",
  null
  
)

export default component.exports